export default __webpack_public_path__ + "static/media/icon_facebook.6a4f7a99.svg";